import React from "react"
import getMimeTypes from "./getMimeTypes"


const FileUploader = (props) => {
  const { accept, handleChange, overrideId } = props
  const mimeTypes = getMimeTypes(Array.isArray(accept) ? accept : [accept])

  const onChange = (event) => {
    event.persist()

    if (event.target?.files) {
      const file = event.target.files[0]
      handleChange({ file, files: [...event.target.files] })
      event.target.value = null
    }
  }

  return (
    <input
      type="file"
      id={overrideId || "file-uploader"}
      accept={mimeTypes}
      onChange={onChange}
      style={{ display: "none" }}
    />
  )
}

export default FileUploader
